import { render, staticRenderFns } from "./japanese_resources.vue?vue&type=template&id=6f1dd2fa&scoped=true"
import script from "./japanese_resources.vue?vue&type=script&lang=js"
export * from "./japanese_resources.vue?vue&type=script&lang=js"
import style0 from "./japanese_resources.vue?vue&type=style&index=0&id=6f1dd2fa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1dd2fa",
  null
  
)

export default component.exports